<style lang="scss">
    $brand-primary: #b47e00;
    $brand-secondary: #343a40;
    $warning: #dc3545;
    $font-color: #4d4d4d;
    $heading-color: #4d4d4d;
    $bg-color: darken(#fafbfc, 3%);

    @import '../src/assets/css/normalize.scss';
    @import '../src/assets/css/global.scss';
    @import '../src/assets/css/badge.scss';
    @import '../src/assets/css/form.scss';
    @import '../src/assets/css/app.scss';
    @import '../src/assets/css/home.scss';
    @import '../src/assets/css/detail.scss';
    @import '../src/assets/css/account.scss';
    @import '../src/assets/css/users.scss';
    @import '../src/assets/css/modal.scss';

</style>

<template>
    <div id="app">
        <div class="loading-backdrop" v-if="dataLoading">
            <div class="loading">
                <fa icon="spinner" class="fa-spin"/>
                Loading ...
            </div>
        </div>

        <div class="sidebar">
            <div class="logo">
                <router-link to="/"><img src="@/assets/logo.svg"></router-link>
                Shopware Konfigurator
            </div>

                <template v-if="getAuthenticated()">
                    <nav class="navi" v-bind:class="{'navi-login': !getAuthenticated()}">
                        <ul>
                            <li>
                                <fa icon="edit"></fa> Projekte
                                <div class="navi--add-project" @click="addNewProject()">+</div>
                                <ul>
                                    <li v-for="(project, pIndex) in filterProjects" :key="pIndex">
                                        <router-link :to="{ name: 'project', params: { projectId: project.id }}">{{project.title}}</router-link>
                                    </li>
                                </ul>
                                <router-link to="/" class="navi--more" v-if="filterProjects.length > 10">mehr...</router-link>
                            </li>
                            <li v-if="userData.role === 'admin'">
                                <router-link to="/users">
                                    <fa icon="user"></fa> Benutzer
                                </router-link>
                            </li>
                            <li v-if="userData.role === 'admin'">
                                <router-link to="/settings">
                                    <fa icon="cog"></fa> Settings
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                    <div class="navi--account">
                        <ul>
                            <li class="account">
                                <div class="account--avatar">
                                    <fa icon="user"/>
                                </div>
                                <router-link to="/account">{{userData.username}}</router-link>
                                <ul>
                                    <li>
                                        <router-link to="/login" v-on:click.native="logout()">
                                            <fa icon="sign-out-alt"/>
                                            Logout
                                        </router-link>
                                    </li>

                                </ul>
                            </li>
                        </ul>
                    </div>
                </template>
        </div>

        <div class="wrapper">

            <template v-if="settingsLoaded || $route.name === 'login'">
                <router-view :settings="settings" :projects="projects" :userData="userData" @authenticated="setAuthenticated"/>
            </template>
            <template v-else>
                <div class="content">
                    <fa icon="spinner" class="fa-spin"/>
                    Loading ...
                </div>
            </template>

            <div class="footer">
                <div class="footer-box footer-box-left">
                    VIERPUNKT GmbH – kreativ punkten | © 2019 · Greiters 350 · 87764 Legau<br/>
                    <strong>Version:</strong> {{settings.version}}
                </div>
                <!--
                <div class="footer-box footer-box-right">
                    <ul>
                        <li><a href="https://capture-system.de/impressum">Impressum</a></li>
                        <li><a href="https://capture-system.de/datenschutz">Datenschutz</a></li>
                    </ul>
                </div>
                -->
            </div>

        </div>

        <div></div>

        <v-dialog />
        <notifications />

    </div>
</template>

<script>

    export default {
        name: 'app',
        components: {},
        data() {
            return {
                msg: false,
                projects: [],
                dataLoading: false,
                settings: {},
                settingsLoaded: false,
                userData: false,
                saving: false,
                projectsIntervall: null
            }
        },
        beforeMount: function () {
            let me = this;

            // Check Login
            if (!me.getAuthenticated()) {
                me.$http.get('/data/auth').then(function (r) {
                    let response = r.data;

                    if (response.data) {
                        me.userData = response.data;

                        me.initData(function () {
                            me.setAuthenticated(true);
                        });

                    } else {
                        me.$router.replace({name: 'login'});
                    }
                }).catch(function () {
                    me.$router.replace({name: 'login'});
                    me.$notify({
                        text: 'cannot connect to login server',
                        type: 'error',
                        duration: -1
                    });
                });
            }
        },
        computed: {
            filterProjects: function() {
                return this.projects.filter(function (project) {
                    return project.status !== 'reject'
                }).sort(this.dynamicSort('-createDate'))
            }
        },
        methods: {
            setAuthenticated(status) {
                this.$root.authenticated = status;
            },
            getAuthenticated() {
                return this.$root.authenticated;
            },
            logout() {
                let me = this;

                me.setAuthenticated(false);

                me.$http.delete('/data/auth').then(function() {
                    me.$router.replace({name: 'login'});
                });
            },
            loadBackdrop: function (state) {
                let me = this,
                    t = 1;

                if (state === false) {
                    t = 200;
                }

                setTimeout(function () {
                    me.dataLoading = state;
                }, t);

            },
            initData: function (callback) {
                let me = this;

                me.loadBackdrop(true);

                me.$http.get('/data/settings').then(function (r) {
                    me.$set(me, 'settings', r.data.settings);

                    me.loadProjects(function() {
                        me.settingsLoaded = true;

                        // Callback for do after loadData data successfully
                        if (typeof callback === 'function') {
                            callback();
                        }

                        me.loadBackdrop(false);

                        me.projectsInterval = setInterval(() => {
                            me.loadProjects();
                        }, 30000);
                    });
                });
            },
            addNewProject: function() {
                let me = this;

                me.$http.post('/data/projects').then(function (r) {
                    let response = r.data;

                    if (response.projects) {
                        me.$set(me, 'projects', response.projects);
                        me.$router.push({name: 'project', params: {projectId: response.newId}});
                        me.$notify({
                            text: response.msg,
                            type: response.msgType
                        });
                    } else {
                        me.$notify({
                            text: response.msg,
                            type: 'error',
                            duration: -1
                        });
                    }
                });
            },
            loadProjects: function(callback) {
                let me = this;

                me.$http.get('/data/projects').then(function (r) {
                    if (r.data.projects) {
                        me.$set(me, 'projects', r.data.projects);
                    }

                    // Callback for do after loadData data successfully
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }
        }
    }

</script>
